// eslint-disable-next-line
import { ConnectingAirportsOutlined } from "@mui/icons-material";
import { Button, CircularProgress, Stack, TextField,Box } from "@mui/material";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState,useEffect } from "react";
import { useHistory, Link } from "react-router-dom";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Login.css";

const Login = () => {
  const { enqueueSnackbar } = useSnackbar();
  const forminit = {
    username: "",
    password: "",
  };
  const [formData, setform] = useState(forminit);
  const [isLoading, setIsLoding] = useState(false);
  const [success,setSuccess]=useState(false);
  const history = useHistory();

  // TODO: CRIO_TASK_MODULE_LOGIN - Fetch the API response
  /**
   * Perform the Login API call
   * @param {{ username: string, password: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/login"
   *
   * Example for successful response from backend:
   * HTTP 201
   * {
   *      "success": true,
   *      "token": "testtoken",
   *      "username": "criodo",
   *      "balance": 5000
   * }
   *
   * Example for failed response from backend:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Password is incorrect"
   * }
   *
   */
  // eslint-disable-next-line
  useEffect(()=>{
    if(success){
      history.push('/');
    }
  },[success,history])
  const login = async (formData) => {
    setIsLoding(true);
    if (validateInput(formData)) {
      await axios
        .post(`${config.endpoint}/auth/login`, {
          username: formData.username,
          password: formData.password,
        })
        .then((res) => {
          // console.log(res.data.success)
          // console.log(res.data.username)
          // console.log(res.data.balance);
          // history.push("/")
          if (res.data.success) {
            enqueueSnackbar("Logged in", {
              variant: "success",
            });
            persistLogin(
              res.data.token,
              res.data.username,
              res.data.balance
            );
            setSuccess(true);
          }
        })
        .catch((e) => {
          if(!e.response.data.success&&e.response.status===400){
            enqueueSnackbar(e.response.data.message,{varient:"error"})
          }
        });
    }
      setIsLoding(false);
      
  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Validate the input
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false and show warning message if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that password field is not an empty value - "Password is a required field"
   */
  // eslint-disable-next-line
  const validateInput = (data) => {
    if (!data.username) {
      enqueueSnackbar("Username is a required field", { variant: "error" });
      return false;
    }
    if (!data.password) {
      enqueueSnackbar("Password is a required field", { variant: "error" });
      return false;
    }
    return true;
  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Persist user's login information
  /**
   * Store the login information so that it can be used to identify the user in subsequent API calls
   *
   * @param {string} token
   *    API token used for authentication of requests after logging in
   * @param {string} username
   *    Username of the logged in user
   * @param {string} balance
   *    Wallet balance amount of the logged in user
   *
   * Make use of localStorage: https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage
   * -    `token` field in localStorage can be used to store the Oauth token
   * -    `username` field in localStorage can be used to store the username that the user is logged in as
   * -    `balance` field in localStorage can be used to store the balance amount in the user's wallet
   */
  // eslint-disable-next-line
  const persistLogin = (token, username, balance) => {
    localStorage.setItem("token", token);
    localStorage.setItem("username", username);
    localStorage.setItem("balance", balance);
  };

  const handelchange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setform({ ...formData, [name]: value });
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons={true} />
      <Box className="content">
        <Stack spacing={2} className="form">
          <h2 className="title">Login</h2>
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            onChange={handelchange}
            fullWidth
          />
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            fullWidth
            onChange={handelchange}
          />
          {isLoading ? (
            <div className="loading">
              <CircularProgress />
            </div>
          ) : (
            <Button
              onClick={(e) => {
                e.preventDefault();
                login(formData);
              }}
              className="button"
              variant="contained"
            >
              LOGIN TO QKART
            </Button>
          )}
          <p className="secondary-action">
            Don’t have an account?{" "}
            <Link className="link" to={`/register`}>
              Register now
            </Link>
          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Login;
